import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { map } from 'rxjs';
import { Selectable } from '../models/types/selectable.type';
import { GetQuery } from '../../models/shared/enums/get-query.enum';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WrapperResultGraphQL } from '../../models/shared/types/wrapper-result-graphql.type';
import { PageInfo } from '../../models/shared/types/page-info.type';
import { StyleDescription } from '../../models/company/style-description.type';

@Injectable({
  providedIn: 'root'
})
export class StyleDescriptionFilterService extends IFilterListService<StyleDescription> {
  pageInfo: PageInfo = { hasPreviusPage: false, hasNextPage: false, startCursor: null, endCursor: null };

  search(searchText: string, variables, isFirst: boolean): void {
    if (searchText || isFirst) this.pageInfo = { ...this.pageInfo, endCursor: null, startCursor: null };

    this.graphQlService.getData<StyleDescription>(GetQuery.GET_STYLE_DESCRIPTIONS_NO_IDS, { search: searchText, companyId: this.appService.companyId, first: variables.first, after: this.pageInfo.endCursor })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(res => res['data']['styleDescriptions'])
      )
      .subscribe({
        next: (res: WrapperResultGraphQL<StyleDescription>) => {
          let datasource: Array<Selectable<StyleDescription>> = [];
          if (this.pageInfo.endCursor) {
            const actualValue = this.datasource.getValue();
            datasource = [...actualValue, ...res.nodes.map(el => ({ ...el, displayId: el.id!, displayName: el.name, disabled: false, selected: false }))];
          } else {
            datasource = res.nodes.map(el => ({ ...el, displayId: el.id!, displayName: el.name, disabled: false, selected: false }));
          }

          this.pageInfo = res.pageInfo;
          this.datasource.next(datasource);
        }
      })
  }
}
